import { Link } from "react-router-dom";
import { GetIdentifierFromName } from "../util/peopleProto";
import { Anchor } from "@mantine/core";

// ResourceLink displays a link to a resource
export const ResourceLink = ({ resourceName, isLink }: { resourceName: string, isLink?: boolean}) => (
  (isLink === true || isLink === undefined) ? <Link to={`/${resourceName}`}>{GetIdentifierFromName(resourceName)}</Link> : <Anchor>{GetIdentifierFromName(resourceName)}</Anchor>
);
